var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrancSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 40C320 44.422 316.406 48 312 48H104C90.781 48 80 58.766 80 72V208H280C284.406 208 288 211.578 288 216S284.406 224 280 224H80V336H216C220.406 336 224 339.578 224 344S220.406 352 216 352H80V472C80 476.422 76.406 480 72 480S64 476.422 64 472V352H8C3.594 352 0 348.422 0 344S3.594 336 8 336H64V72C64 49.938 81.938 32 104 32H312C316.406 32 320 35.578 320 40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrancSign);
export default __webpack_public_path__ + "static/media/franc-sign.26cb3a8f6ff26cd27cf51e15dfaef2c5.svg";
export { ForwardRef as ReactComponent };